import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

export default {
  bind(el, binding) {
    el.dataset.tag = binding.value; // Etiketi ata
    el.addEventListener('click', () => {
      const tag = el.dataset.tag; // Etiket bilgisi
      if (tag) {
        communicationService.sendDataToParent({
          key: dataKeys.STATISTICS,
          value: tag,
        });
      }
    });
  },
};